import { useNavigate } from "react-router-dom";

import { useSelector } from 'react-redux';

import { formatDate } from '../../../common/formatDateText';
import { urlFlag } from '../../../common/urlBase';
import { AcademicCapIcon } from '@heroicons/react/24/solid';
import { CourseWeekDaysGrid } from './CourseWeekDaysGrid';
import { isStudentCourseEntryPaid } from '../../../constants/courseEntry';


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const CardCourseDisplay = ({
    id,
    headerImage,
    language,
    level,
    color,
    path,
    status,
    teacher,
    fromDate,
    toDate,
    days,
    hours,
    action = false,
    identifier
}) => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.user);
    const { typeUser } = user;
    const canViewCourseContent = ['estudiante', 'profesor', 'control escolar', 'director', 'administrativo', 'ventas', 'cobranza'];

    const disabledButtonStatus = ['completado', 'cancelado'];

    const handleGoToCourse = (idCourse) => () => {
        navigate(`/curso/${idCourse}`);
    }

    return (
        <div className='w-full mx-auto flex flex-col shadow-md shadow-indigo-950/20 rounded-md mt-4 bg-white'>
            <div className="overflow-hidden">
                {
                    headerImage !== undefined
                        ? (
                            <div className="">
                                <img className="w-full rounded-t-md object-contain hover:object-scale-down" src={headerImage} alt="header" />
                            </div>
                        )
                        : null
                }

            </div>
            <div className='w-full flex flex-col p-4'>
                <div className="flex justify-between">
                    <div>
                        <p className='text-lg text-gray-900 font-bold tracking-wide uppercase'>{language ? `Curso de ${language}` : 'No hay idioma selecionado'}</p>
                        <div className="flex items-center gap-2">
                            <div className="flex items-center justify-center gap-2">
                                <div className="relative flex items-center justify-center">
                                    <span className={classNames(
                                        color,
                                        'absolute w-[10px] h-[10px] rounded-lg animate-ping opacity-75'
                                    )}></span>
                                    <span className={classNames(
                                        color,
                                        'relative flex w-[10px] h-[10px] rounded-lg'
                                    )}></span>
                                </div>
                                <p className='text-md text-indigo-700 font-bold tracking-wide uppercase'>{level}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        {path
                            ? (
                                <img className="w-[42px]" src={`${urlFlag}${path}`} alt="flag" />
                            )
                            : null}
                    </div>
                </div>

                <div className="w-full grid grid-cols-1 md:grid-cols-2">
                    <div className="w-full flex flex-col justify-center items-center mt-2 md:mt-6 ">
                        <p className="font-normal text-sm text-gray-600 leading-6">Estatus del curso</p>
                        <div
                            className={classNames(
                                status === 'abierto'
                                    ? 'text-sky-700 bg-sky-100 border-sky-200'
                                    : status === 'en curso' ? 'text-emerald-500 bg-emerald-100 border-emerald-200'
                                        : status === 'completado' ? 'text-indigo-600 bg-indigo-100 border-indigo-200'
                                            : status === 'cancelado' ? 'text-gray-600 bg-gray-100 border-gray-200'
                                                : status === 'finalizado' ? 'text-rose-500 bg-rose-100 border-rose-200' : null,
                                'shadow-sm px-4 py-1 rounded-md uppercase font-bold border-[1px]'
                            )}>
                            <p className="text-[.9rem] font-bold uppercase">{status}</p>
                        </div>
                    </div>
                    <div className="w-full flex flex-col justify-center items-center mt-2 md:mt-6 ">
                        <p className="font-normal text-sm text-gray-600 leading-6">Identificador del curso</p>
                        <p className="w-full text-slate-800 font-semibold text-[.9rem] tracking-wide capitalize truncate py-1 text-center">{identifier !== '' ? `[ ${identifier} ]` : '-'}</p>
                    </div>
                </div>

                <div className="w-full grid grid-cols-1 md:grid-cols-2 mt-6">
                    <div className="w-full flex flex-col justify-center items-center">
                        <p className="font-normal text-sm text-gray-600 leading-6">Profesor del curso</p>
                        <p className="text-slate-800 font-semibold text-sm tracking-wide capitalize py-1">{teacher !== '' ? teacher : '-'}</p>
                    </div>
                    <div className="w-full flex flex-col justify-center items-center">
                        <p className="font-normal text-sm text-gray-600 leading-6">Horario</p>
                        <p className="text-slate-800 font-semibold text-sm tracking-wide py-1">{
                            hours !== undefined
                                ? `${hours.length > 0 ? hours[0]?.time : ''} - ${hours.length > 0 ? hours[hours?.length - 1]?.time : ''}`
                                : 'No hay tiempo selecionado'
                        }</p>
                    </div>
                </div>


                <div className="w-full grid grid-cols-1 md:grid-cols-2 mt-2 md:mt-6">
                    <div className='flex flex-col justify-center items-center'>
                        <span className="font-normal text-sm text-gray-600 leading-6">Inicio de curso</span>
                        <span className="w-full text-slate-800 font-semibold text-sm tracking-wide capitalize text-center truncate py-1">{fromDate !== '' ? formatDate(fromDate) : '-'}</span>
                    </div>
                    <div className='flex flex-col justify-center items-center'>
                        <span className="flex font-normal text-sm text-gray-600 leading-6">Fin de curso</span>
                        <span className="w-full text-slate-800 font-semibold text-sm tracking-wide capitalize text-center truncate py-1">{toDate !== '' ? formatDate(toDate) : '-'}</span>
                    </div>
                </div>



                <div className="w-[95%] mx-auto flex flex-col justify-center mt-6 px-4">
                    <p className="w-full text-center md:text-start font-normal text-sm text-gray-600 leading-6 mb-4">Dias de clase</p>
                    <CourseWeekDaysGrid days={days} />
                </div>
                <div className="w-full flex justify-center items-center mt-6">

                    {
                        action && canViewCourseContent.includes(typeUser) && (
                            <button
                                onClick={handleGoToCourse(id)}
                                disabled={!isStudentCourseEntryPaid(user) || disabledButtonStatus.includes(status)}
                                className="w-full flex justify-center items-center gap-2 py-3.5 px-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl 
                        shadow-lg shadow-indigo-500/50 hover:shadow-xl hover:shadow-indigo-600/50 
                        transform hover:-translate-y-0.5 transition-all duration-300 
                        disabled:cursor-not-allowed disabled:opacity-60 disabled:transform-none disabled:shadow-md disabled:bg-gradient-to-r disabled:from-slate-400 disabled:to-slate-500
                        focus:outline-none focus:ring-4 focus:ring-indigo-300
                        relative overflow-hidden group"
                            ><AcademicCapIcon className="block h-4 w-4" aria-hidden="true" />Ir a curso</button>
                        )
                    }
                </div>

            </div>
        </div>
    )
}
